<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <card class="card-nav-tabs" header-classes="card-header-warning">
          <h4 class="card-title">商店參數</h4>
          <div class="row">
            <div class="col-sm-4">
              <p class="card-text">
                <b>商店名稱：</b>
                {{businessData.businessName}}
              </p>
            </div>
            <div class="col-sm-4">
              <p class="card-text">
                <b>商店電話：</b>
                {{businessData.businessPhone}}
              </p>
            </div>
            <div class="col-sm-4">
              <p class="card-text">
                <b>商店Email：</b>
                {{businessData.businessEmail}}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <p class="card-text">
                <b>商店地址：</b>
                {{businessData.businessAddress}}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-10">
              <p class="card-text">
                <b>商店綁定碼：</b>
                {{businessData.code}}（綁定碼到期時間: {{localTime}}）
                <button @click="updateCode()">更新綁定碼</button>
              </p>
            </div>
          </div>
           <div class="row" v-if="businessData.lineAddFriendUrl">
            <div class="col-sm-10">
              <p class="card-text"><b>LINE@加好友連結：</b><a :href="businessData.lineAddFriendUrl" target="_blank">{{businessData.lineAddFriendUrl}}</a></p>
            </div>
          </div>
          <div class="row" v-if="businessData.lineBasicId">
            <div class="col-sm-10">
              <p class="card-text"><b>LINE@加好友ID：</b>{{businessData.lineBasicId}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-10">
              <p class="card-text">
                <b>Webhook URL:</b>
                {{webhookUrl}}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-10">
              <p class="card-text">
                <b>Menu URL:</b>
                {{managerInfo.menuUrl}}
                <input type="hidden" id="menu-url" :value="managerInfo.menuUrl">
                <button @click="copyMenuUrl()">複製</button>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-10">
              <p class="card-text">
                <b>Order URL:</b>
                {{managerInfo.orderUrl}}
                <input type="hidden" id="order-url" :value="managerInfo.orderUrl">
                <button @click="copyOrderUrl()">複製</button>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-10">
              <p class="card-text">
                <b>Info URL:</b>
                {{managerInfo.infoUrl}}
                <input type="hidden" id="info-url" :value="managerInfo.infoUrl">
                <button @click="copyInfoUrl()">複製</button>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-10">
              <p class="card-text">
                <b>17life Shopping URL:</b>
                {{managerInfo._17LifeShoppingUrl}}
                <input type="hidden" id="_17-life-shopping-url" :value="managerInfo._17LifeShoppingUrl">
                <button @click="copy17LifeShoppingUrl()">複製</button>
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-3">
              <card class="card-nav-tabs" header-classes="card-header-warning">
                <img
                  slot="image"
                  class="card-img-top"
                  :src="managerInfo.qrcodeUrl"
                  alt="Card image cap"
                />
                <p class="card-text">管理後台</p>
              </card>
            </div>
            <div class="col-xs-3">
              <card class="card-nav-tabs" header-classes="card-header-warning">
                <img
                  slot="image"
                  class="card-img-top"
                  :src="businessData.lineChannelImageUrl"
                  alt="my business"
                />
                <p class="card-text">{{businessData.businessName}}</p>
              </card>
            </div>
            <div class="col-xs-3" v-if="notify.lineUrl">
              <card class="card-nav-tabs" header-classes="card-header-warning">
                <img
                  slot="image"
                  class="card-img-top"
                  :src="notify.lineUrl"
                  :alt="notify.name"
                />
                <p class="card-text">{{notify.name}}</p>
              </card>
            </div>
          </div>
          <n-button native-type="button" type="gray" @click.native="home()">回商店列表</n-button>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import ElementUI from "element-ui";
import { fetchShopInfo, fetchManagerInfo } from "src/javascripts/generalPages/fetchData";
import { updateCode } from "src/javascripts/generalPages/postData";
import moment from "moment-timezone";
import axios from "axios";
var type;
var bType;
var siAccountId;
var id;
export default {
  beforeRouteEnter(to, from, next) {
    console.log("this.$route: ", to);
    id = to.params.id;
    type = to.params.type;
    bType = to.query.type;
    siAccountId = to.query.siAccountId;
    fetchShopInfo(id, type)
      .then(res => {
        next(vm => vm.setData(res.data));
      })
      .catch(err => {
        console.log("err: ", err);
      });
  },
  created: function() {
    fetchManagerInfo(siAccountId, type, bType, id)
    .then(res => {
      if(res.data.length > 0) {
        this.managerInfo = Object.assign({}, {...res.data[0]});
        console.log("managerInfo: ", this.managerInfo)
      };
    })
    .catch(err => {
      console.log("fetchManagerInfo err: ", err.stack)
    })
  },
  data() {
    return {
      title: "yoyo",
      id: "",
      businessData: {},
      webhookUrl: "",
      localTime: "",
      notify: {},
      managerInfo: {
        qrcodeUrl: "https://qr-official.line.me/sid/L/398dmpnt.png",
        webhookUrlDomain: "quickclick.cc",
        menuUrl: "",
        orderUrl: ""
      }
    };
  },
  computed: {
    user: function() {
      return this.$store.getters.user;
    }
  },
  methods: {
    getNotify() {
      
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/line-notify-groups?business_id=${this.$route.params.id}`
        )
        .then(response => {
          if (response && response.data && response.data[0]) {
            this.notify = response.data[0].subscriberAttributes;
            if (this.notify.lineUrl) {
              this.notify.lineUrl = `https://chart.googleapis.com/chart?cht=qr&chs=350x350&choe=UTF-8&chl=${encodeURIComponent(this.notify.lineUrl)}`;
            }
          }
          return;
          // return response.data;
        })
        .catch(e => {
          
          // if (e && e.data && e.data.message)
          //   this.modals.content = e.data.message;

          // this.modals.mini = true;
        });
    },
    setData: function(data) {
      this.businessData = data;
      this.businessData.managerQRCode =
        "https://qr-official.line.me/sid/L/398dmpnt.png";
    },
    home: function() {
      window.history.back();
    },
    updateCode() {
      let accountId = this.businessData.accountId;
      updateCode(accountId, type)
        .then(res => {
          let code = res.data.results.code;
          let expiredTime = res.data.results.expiredTime;
          this.businessData.localTimeZone = moment(expiredTime)
            .tz("Asia/Taipei")
            .format("YYYY-MM-DD HH:mm:ss");
          this.businessData.code = code;
        })
        .catch(err => {
          console.log("genCodeConfig err: ", err);
        });
    },
    copyMenuUrl() {
      let textToCopy = document.querySelector("#menu-url");
      textToCopy.setAttribute('type', 'text');
      textToCopy.select();
      var successful = document.execCommand("copy");
      textToCopy.setAttribute('type', 'hidden');
      if(successful){
        this.$message({
          type: 'success', message: `已複製`
        });
      } else {
        this.$message({
          type: 'warning', message: `錯誤`
        });
      }
    },
    copyOrderUrl() {
      let textToCopy = document.querySelector("#order-url");
      textToCopy.setAttribute('type', 'text');
      textToCopy.select();
      var successful = document.execCommand("copy");
      textToCopy.setAttribute('type', 'hidden');
      if(successful){
        this.$message({
          type: 'success', message: `已複製`
        });
      } else {
        this.$message({
          type: 'warning', message: `錯誤`
        });
      }
    },
    copyInfoUrl() {
      let textToCopy = document.querySelector("#info-url");
      textToCopy.setAttribute('type', 'text');
      textToCopy.select();
      var successful = document.execCommand("copy");
      textToCopy.setAttribute('type', 'hidden');
      if(successful){
        this.$message({
          type: 'success', message: `已複製`
        });
      } else {
        this.$message({
          type: 'warning', message: `錯誤`
        });
      }
    },
    copy17LifeShoppingUrl() {
      let textToCopy = document.querySelector("#_17-life-shopping-url");
      textToCopy.setAttribute('type', 'text');
      textToCopy.select();
      var successful = document.execCommand("copy");
      textToCopy.setAttribute('type', 'hidden');
      if(successful){
        this.$message({
          type: 'success', message: `已複製`
        });
      } else {
        this.$message({
          type: 'warning', message: `錯誤`
        });
      }
    }
  },
  mounted() {
    let self = this;
    
    if (this.$route.params.id) {
      
      this.getNotify();
    }
  },
  updated: function() {
    this.webhookUrl = `https://${this.managerInfo.webhookUrlDomain}/line/general/${this.businessData.lineChannelId}/code/${this.businessData.randomCode}`;
    this.localTime = moment(this.businessData.localTimeZone)
      .tz("Asia/Taipei")
      .format("YYYY-MM-DD HH:mm:ss");
  }
};
</script>